import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { locationsActions } from '../../behavior/locations';

const detailsTheme = createTheme({
  typography: { fontFamily: 'inherit' },
  palette: { mode: 'light' },
});

const CHIP_BLUE = '#2185d0';

const keySx = {
  fontSize: 10.5,
  letterSpacing: '0.14em',
  textTransform: 'uppercase',
  color: 'rgba(0, 0, 0, 0.55)',
  mr: 0.5,
};

const chipSx = {
  display: 'inline-block',
  fontSize: 13,
  fontWeight: 600,
  lineHeight: 1.5,
  color: CHIP_BLUE,
  border: `1px solid ${CHIP_BLUE}`,
  borderRadius: '4px',
  padding: '2px 10px',
  verticalAlign: 'baseline',
};

const BBuildingDetailsContainer = ({ values }) => {
  const { locationAisPubDetails } = values;
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const buildingSummaryLocationId = useSelector(
    state => state?.locations?.summary?.buildingSummary?.location?.id,
  );
  const watercourseName = useSelector(
    state => state?.locations?.watershed?.watercourse,
  );

  useEffect(() => {
    dispatch(locationsActions.getWatershedByLocation(buildingSummaryLocationId));
  }, [buildingSummaryLocationId]);

  const rows = [
    {
      label: 'building.summary.page.department.label',
      value: locationAisPubDetails.department,
    },
    {
      label: 'building.summary.page.site.label',
      value: locationAisPubDetails.site,
    },
    {
      label: 'building.summary.page.commune.label',
      value: locationAisPubDetails.commune,
    },
    {
      label: 'building.summary.page.surface.label',
      value: locationAisPubDetails.surface,
      suffix: ' m²',
    },
    {
      label: 'building.summary.page.watercourse.label',
      value: watercourseName,
    },
    {
      label: 'building.summary.page.description.label',
      value: locationAisPubDetails.description,
    },
  ].filter(row => row.value !== null && row.value !== undefined && row.value !== '');

  return (
    <ThemeProvider theme={detailsTheme}>
      <Box sx={{ my: 0.25, fontSize: 13, lineHeight: 1.6 }}>
        {rows.map(row => (
          <Box
            key={row.label}
            component="span"
            sx={{ display: 'inline-block', mr: 1.5, mb: 0.25 }}
          >
            <Box component="span" sx={keySx}>
              {t(row.label)}
            </Box>
            <Box component="span" sx={chipSx}>
              {row.value}
              {row.suffix}
            </Box>
          </Box>
        ))}
      </Box>
    </ThemeProvider>
  );
};

export default BBuildingDetailsContainer;
